import { ZERO } from '@/constants';
import { Avatar, Chip, Icon, Typography } from '@/ui';

import type { Company } from '@/types';
import type { FC, ReactNode } from 'react';

const About: FC<{
  company: Company;
  titleAction?: ReactNode;
}> = ({ company, titleAction }) => {
  let pocInfo = company.pocName || '';

  if (company.pocName && company.pocEmail) {
    pocInfo += `, ${company.pocEmail}`;
  } else if (company.pocEmail) {
    pocInfo += company.pocEmail;
  }

  const formatSessionTimeout = (seconds: number) => {
    const days = Math.floor(seconds / (24 * 60 * 60));
    const hours = Math.floor((seconds % (24 * 60 * 60)) / (60 * 60));
    const mins = Math.floor((seconds % (60 * 60)) / 60);

    if (days > 0) {
      return `${days} day${days > 1 ? 's' : ''}${hours > 0 ? `, ${hours} hour${hours > 1 ? 's' : ''}` : ''}`;
    }
    if (hours > 0) {
      return `${hours} hour${hours > 1 ? 's' : ''}${mins > 0 ? `, ${mins} minute${mins > 1 ? 's' : ''}` : ''}`;
    }
    return `${mins} minute${mins > 1 ? 's' : ''}`;
  };

  return (
    <div className="flex flex-col items-center justify-center gap-2">
      <Avatar
        icon="domain"
        iconClassName="text-5xl"
        size="xl"
        src={company.avatarUrl}
      />
      {/* min-w-0/break-words let a long unbroken company name wrap instead of
          overflowing the panel; the row stays shrink-to-fit so the approved
          centering is unchanged. */}
      <div className="flex min-w-0 items-center gap-1">
        <Typography className="min-w-0 break-words" variant="h4">
          {company.name}
        </Typography>
        {titleAction}
      </div>
      <div className="mb-4 flex gap-2">
        <Icon>groups</Icon>
        <Typography variant="body1">
          {company.usersCount || ZERO} members
        </Typography>
      </div>
      {!!company.domains.length && (
        <Chip color="info" label={company.domains.join(', ')} />
      )}
      {!!pocInfo.length && (
        <Chip
          color="default"
          icon={<Icon>account_box</Icon>}
          label={`PoC: ${pocInfo}`}
        />
      )}
      {!!company.adminEmails.length && (
        <Chip
          color="default"
          icon={<Icon>admin_panel_settings</Icon>}
          label={`Admins: ${company.adminEmails.join(', ')}`}
        />
      )}
      {company.sessionTimeoutLength && (
        <Chip
          color="secondary"
          icon={<Icon>schedule</Icon>}
          label={`Session timeout: ${formatSessionTimeout(company.sessionTimeoutLength)}`}
        />
      )}
    </div>
  );
};

export default About;
